import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

const ROUTE_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  classrooms: 'Classrooms',
  dictionaries: 'Dictionaries',
  probes: 'Probes',
  builder: 'Builder',
  'my-classes': 'My Classes',
  'take-probe': 'Take Probe',
  results: 'Results',
  settings: 'Settings',
  enroll: 'Enroll',
  login: 'Login',
};

export function useBreadcrumbs(currentPageLabel?: string): BreadcrumbItem[] {
  const location = useLocation();
  const params = useParams();

  return useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const items: BreadcrumbItem[] = [];
    let pathAccumulator = '';

    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i] ?? '';
      pathAccumulator += `/${segment}`;

      const isUuid = /^[0-9a-f-]{36}$/i.test(segment);
      const isParamValue = Object.values(params).includes(segment);

      if (isUuid || isParamValue) {
        continue;
      }

      const isLastSegment = i === segments.length - 1;
      const label = ROUTE_LABELS[segment] ?? segment;

      items.push({
        label,
        href: isLastSegment ? undefined : pathAccumulator,
      });
    }

    if (currentPageLabel && items.length > 0) {
      const lastItem = items[items.length - 1];
      if (lastItem) lastItem.label = currentPageLabel;
    }

    return items;
  }, [location.pathname, params, currentPageLabel]);
}
